module.exports = __webpack_public_path__ + "img/container_front_right.3d8fd6b5.svg";